import {ApolloClient, useApolloClient} from "@apollo/client";
import log from "loglevel";
import {useContext, useEffect, useState} from "react";
import {DispatchConfigurationContext} from "../providers/DispatchConfigurationProvider";
import {GeoCodeService, GeoCodeServiceProperties, getGeoCodeService} from "../services/GeoCodeService";

type UseGeoCodeServiceProps = {
  apolloClientHook: () => ApolloClient<any>;
};
const useGeoCodeService = (
  {apolloClientHook}: UseGeoCodeServiceProps = {
    apolloClientHook: useApolloClient
  }
): GeoCodeService => {
  const [geocodeService, setGeocodeService] = useState<GeoCodeService>();
  const apolloClient = apolloClientHook();
  const {geocodingServiceType} = useContext(DispatchConfigurationContext);

  useEffect(() => {
    const geoCodeServiceProps = {
      apolloClient: apolloClient,
      serviceType: geocodingServiceType
    } as GeoCodeServiceProperties;
    log.debug("Obtaining geocode service based on properties: ", geoCodeServiceProps);
    setGeocodeService(getGeoCodeService(geoCodeServiceProps));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [geocodingServiceType]);
  return geocodeService as GeoCodeService;
};

export {useGeoCodeService};
export type {UseGeoCodeServiceProps};
